<!-- <app-loader [loading]="loading"></app-loader> -->
<div class="wrapper">
    <div class="my-2">
      <app-categorybar></app-categorybar>
    </div>
    <!-- <div class="custombg fixed-top">
      <app-header ></app-header>
      <app-breadcrumb></app-breadcrumb>
    </div> -->
    <div class="top-section d-flex w-100">
      
      <div class="button-section ml-3">
            <!-- <mat-icon class="arrow-icon" (click)="navigateBack()">arrow_back</mat-icon> -->
            <span class="material-icons arrow-icon" (click)="navigateBack()">arrow_back</span>
        </div>

      <div class="search-employee w-60 mt-md">
        <label>Search Employee by ID/NAME</label>
        <div class="input-group">
          <input
          
            type="text"
            class="form-control"
            aria-label="Number"
            matInput
            (input)="getFilteredValues($event.target.value)"
            (onfocus)="getFilteredValues('')"
            [matAutocomplete]="partner"
          />
          <!-- <div class="input-group-append">
            <i class="fas fa-search"></i>
          </div> -->
        </div>
        <mat-autocomplete
          autoActiveFirstOption
          #partner="matAutocomplete"
          (optionSelected)="setSelectedEmployeeRoles($event.option.id)"
        >
          <mat-option
            *ngFor="let partner of filteredValues"
            [id]="partner.employeeId"
            [value]="partner.name"
          >
            {{ partner.name }} ({{ partner.employeeId }})
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="d-flex row ">
      <div class="roles-section mt-5 mt-md-3">
        <div *ngFor="let role of roles">
          <div class="title">
            <label
              ><b>{{ role.title }}</b></label
            >
          </div>
          <div class="roles" >
            <div class="superAdmin" *ngIf="role.title != 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="superAdmin"
                (change)="changeRole($event, 'SuperAdmin')"
                [checked]="checkIsChecked('SuperAdmin')"
                [disabled]="(!checkHasAuthorization('SuperAdmin') || isCheckedUser || isEmployeeSearched) || (!checkIsChecked('SuperAdmin') && addedRoles.length>0)"
              />
              <label>SuperAdmin</label>
            </div>
            <div class="superAdmin" *ngIf="role.title != 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="Admin"
                (change)="changeRole($event, 'Admin')"
                [checked]="checkIsChecked('Admin')"
                [disabled]="(!checkHasAuthorization('Admin') || isCheckedUser || isEmployeeSearched || isSuperAdminSelected()) || (!checkIsChecked('Admin') && addedRoles.length>0) "
              />
              <label>Admin</label>
            </div>
            <div class="user" *ngIf="role.title != 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="user"
                (change)="changeRole($event, 'Skill.User')"
                [checked]="checkIsChecked('Skill.User')"
                [disabled]="
                  (!checkHasAuthorization( 'Admin') ||
                  isSuperAdminSelected() || isCheckedUser || isEmployeeSearched) || (!checkIsChecked('Skill.User') && addedRoles.length>0)
                "
              />
              <label>User</label>
            </div>
            <!-- <div class="Admin" *ngIf="role.title != 'Competency' && role.repoName">
              <input
                type="checkbox"
                class="mr-3"
                id="admin"
                (change)="changeRole($event, role.repoName + '.Admin')"
                [checked]="checkIsChecked(role.repoName + '.Admin')"
                [disabled]="
                  !checkHasAuthorization(role.repoName + '.Admin') ||
                  isSuperAdminSelected() || (role.title == 'Skill Repository') || isCheckedUser || isEmployeeSearched
                "
              />
              <label>Admin</label>
            </div> -->
            <div class="Leadership" *ngIf="role.title != 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="admin"
                (change)="changeRole($event, 'Leadership' )"
                [checked]="checkIsChecked('Leadership' )"
                [disabled]="
                  (!checkHasAuthorization(role.repoName) ||
                  isSuperAdminSelected() || isCheckedUser || isEmployeeSearched)|| (!checkIsChecked('Leadership') && addedRoles.length>0)
                "
              />
              <label>Leadership</label>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="admin"
                (change)="changeRole($event, 'CompetencyLeader')"
                [checked]="checkIsChecked('CompetencyLeader')"
                [disabled]="
                  !checkHasAuthorization('CompetencyLeader') ||
                  isSuperAdminSelected() || isCheckedUser || isEmployeeSearched
                "
              />
              <label>CompetencyLeader</label>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'Competency'">
              <input
                type="checkbox"
                class="mr-3"
                id="admin"
                (change)="changeRole($event, 'SubCompetencyLeader')"
                [checked]="checkIsChecked('SubCompetencyLeader')"
                [disabled]="
                  !checkHasAuthorization('SubCompetencyLeader') ||
                  isSuperAdminSelected() || isCheckedUser || isEmployeeSearched
                "
              />
              <label>SubCompetencyLeader</label>
              <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
                <input type="checkbox" class="mr-3" id="admin" #radioButton
                  (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                  [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
                <label>PMO Role</label>
              </div>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
              <input type="checkbox" class="mr-3" id="admin" #radioButton
                (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
              <label>PMO Role</label>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
              <input type="checkbox" class="mr-3" id="admin" #radioButton
                (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
              <label>PMO Role</label>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
              <input type="checkbox" class="mr-3" id="admin" #radioButton
                (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
              <label>PMO Role</label>
            </div>
            <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
              <input type="checkbox" class="mr-3" id="admin" #radioButton
                (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
              <label>PMO Role</label>
            </div>
            <!-- <div class="Leadership" *ngIf="role.repoName == 'TimeSheet'">
              <input type="checkbox" class="mr-3" id="admin" #radioButton
                (change)="changeCPMORole($event, 'Timesheet.Admin')" [checked]="checkIsChecked('Timesheet.Admin')"
                [disabled]="!checkHasAuthorization('Timesheet.Admin') || isCheckedUser || isEmployeeSearched"/>
              <label>PMO Role</label>
            </div> -->
          </div>
        
          
          

        </div>
        
      
      </div>
      <div class="mt-5" *ngIf="comp || subCompChecked" style="margin-left: 15rem;" >
        <h5>Competencies</h5>
        <div  class="d-flex row" *ngFor="let comp of Competencies; let i=index">
          <div class="col-12">
            <input type="checkbox" class="mr-3" [checked]="isCheckedCompetency(comp.id)" (change)="changeOfCompetency($event.target.checked,comp.id,i)" ><label> {{comp.name}}</label>
          </div> 
          <div class="" *ngIf="subCompChecked && checkIt(comp.id)" style="margin-left: 20rem; margin-top: -3.3rem;" >
            <mat-form-field>
              <mat-label>SubCompetency</mat-label>
              <mat-select multiple (selectionChange)="changeOfSubCompetencies($event, comp.id)" [(value)]="selectedCompitencies[i]">
                <mat-option  [value]="0"><span *ngIf="comp && subCompChecked">Select All</span> </mat-option>
                <mat-option *ngFor="let subComp of getData(comp.id)" [value]="subComp.id">
                  {{subComp.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
        
          </div>          
        </div>
      </div>
      
    <!-- <div class="mt-5 ml-15px">
      <table>
        <tr *ngFor="let comp of Competencies">
          <td>
            <input type="checkbox" class="mr-3" (change)="changeOfCompetency($event,comp.id)" ><label> {{comp.name}}</label>
        </td>
        <td>
          <div>
            <mat-form-field>
              <mat-label>SubCompetency</mat-label>
              <mat-select [formControl]="toppings" multiple>
                <mat-select-trigger>
                  {{toppings.value?.[0] || ''}}
                  <span *ngIf="(toppings.value?.length || 0) > 1" class="example-additional-selection">
                    (+{{(toppings.value?.length || 0) - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let subComp of subCompetencies"  [value]="subComp.name">{{subComp.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <angular2-multiselect  name="dropdown-{{user.id}}" [data]="dropdownList" [(ngModel)]="selectedItems[user.id]" 
            [settings]="dropdownSettings" 
            (onSelect)="onItemSelect($event, user.id)" 
            (onDeSelect)="OnItemDeSelect($event,user.id)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelectAll)="onDeSelectAll($event)" disabled></angular2-multiselect>
          </div>
        </td>
      </tr>

      </table>
    </div> -->
    </div>
    <div class="save-section" *ngIf="!isEmployeeSearched || !isCheckedUser">
      <button mat-raised-button (click)="updateRoles()">
        Update
      </button>
    </div>
</div>